import React from 'react';
import './PlusButton.css';

const PlusButton = ({disabled, onClick}) => {
    return (
        <button className='plus_button' onClick={onClick} disabled={disabled} />
    );
};

export default PlusButton;